import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  // Bypass token injection for requests matching excluded URLs
  if (environment.sessionTokenExcludedUrls.some(url => req.url.includes(url))) {
    return next(req);
  }

  // Clone request and include session cookie
  const modifiedReq = req.clone({
    withCredentials: true,
  });

  return next(modifiedReq);
};
